//import React from 'react'
//import {css} from 'glamor'


/*----------- Color variables -----------*/
const dark = '#000' // 34 40 48
const light = '#FFF'
const blue = 'rgb(36, 109, 177)' //#246db1
const blueLight = '#79addd'
const green = '#4CAF50'
// const displayWeb = css({'@media(max-width: 767px)':{display:'none'}})
// const displayMobile = css({'@media(min-width: 767px)':{display:'none'}})
//
// export const JustWeb = ({children}) =>
//  <div {...css({'@media(max-width: 767px)':{display:'none'}})}>{children}</div>
//
// export const JustMobile = ({children}) =>
//  <div {...css({'@media(min-width: 767px)':{display:'none'}})}>{children}</div>




export const myConfig = {
  dark,
  light,
  blue,
  blueLight,
  green
  // displayWeb,
  // displayMobile,
}



// WEBPACK FOOTER //
// ./src/config/myConfig.js